angular.module('impactx.search').controller('SearchListCatalogCtrl', SearchListCatalogController);
SearchListCatalogController.$inject = [
    '$scope',
    'searchFilter',
    'AddToBasketService',
    'SearchService',
    'AppConfiguration',
    'SearchFilter',
    'dataGen',
    'ToolbarService',
    'TranslationService',
    'DownloadService',
    '$routeParams',
    'SearchFilterStorage',
    '$rootScope',
    '$location',
    'BackService'
];

function SearchListCatalogController($scope, searchFilter, AddToBasketService, SearchService, AppConfiguration,
                                     SearchFilter, dataGen, ToolbarService, TranslationService, DownloadService, $routeParams,
                                     SearchFilterStorage, $rootScope, $location, BackService) {
    var self = this;
    self.pageNumber = 1;
    self.showScrollTopButton = false;
    self.showResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    self.resetPageNumber = {value: false};
    var routeChangeFinished = false;
    ToolbarService.showSearchFilterToggle();

    self.search = function (index) {
        if (!index) {
            self.resetPageNumber.value = true;
            self.pageNumber = 1;
        }
        else {
            self.pageNumber = index;
        }

        return SearchService.searchCatalogs(self.pageNumber).then(function (searchResults) {
            self.initialized = true;
            if (searchResults) {
                angular.extend(self, searchResults);
                defineButtons();
            }
        })
    };

    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    var storedSearchFilterObject = SearchFilterStorage.getVCatalogListFilter();
    if (storedSearchFilterObject && backButtonUsed) {
        SearchFilterStorage.removeLastVCatalogListFilter();
        self.filter = storedSearchFilterObject;
        searchFilter.searchInput = self.filter.searchInput.value;
        var guidingClassification =  self.filter.guidingClassification;
        if (guidingClassification && guidingClassification.superEntries) {
            var superEntry = guidingClassification.superEntries[guidingClassification.superEntries.length - 1];
            SearchFilter.setSearchInputClassification(superEntry);
        }
        else {
            SearchFilter.setSearchInputClassification(null);
        }
        SearchFilter.setFilters(self.filter);
        self.search().then(function () {
            if(backButtonUsed) {
                SearchFilterStorage.scrollToSearchScrollPosition("vcatList", '#search-view');
            }
        });
    }
    else {
        self.filter = JSON.parse(JSON.stringify(SearchFilter.getFilters()));
        SearchFilter.setFilters(self.filter);

        if ($routeParams.sortByName)
        {
            SearchFilter.sortByNameASC();
        }

        self.search();
    }

    $scope.$watch(function () {return $location.path()}, function () {
        //this is not triggered when the back button is used.
        if (routeChangeFinished) {
            var searchInputUsed = SearchFilter.getFilters().searchInputUsed;
            SearchFilter.getFilters().searchInputUsed = false;
            SearchFilterStorage.setVCatalogListFilter(self.filter);
            var searchInputClassification = SearchFilter.getSearchInputClassification();
            var guidingClassification = SearchFilter.getGuidingClassification();
            SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
            if (searchInputUsed) {
                SearchFilter.getFilters().searchInput.value = searchFilter.searchInput;
                SearchFilter.setSearchInputClassification(searchInputClassification);
                SearchFilter.setGuidingClassification(guidingClassification);
            }
            else {
                searchFilter.searchInput = "";
            }
            SearchFilterStorage.setSearchFilterPlaceHolder(null);
        }
        routeChangeFinished = true;
    });

    $scope.addToBasket = AddToBasketService.addToBasket;

    self.print = function () {
        var catalogIds = [];
        return SearchService.searchCatalogs(self.pageNumber).then(function (searchResults) {
            if (searchResults) {
                angular.forEach(searchResults.catalogs, function (catalog) {
                    catalogIds.push(catalog.id);
                });
                DownloadService.openDownloadPost('/search/export/catalog', {paramName: "ids", paramValue: catalogIds});
            }
        });
    };

    self.showScrollTop = function (showScrollTop) {
        self.showScrollTopButton = showScrollTop;
    };

    self.scrollToTop = function () {
        angular.element('#search-view').animate({
            scrollTop: 0
        }, 200);
    };

    self.back = function () {
        BackService.back();
        self.filter.listFilters = SearchFilterStorage.getFreshFilter().listFilters;
    }

    function defineButtons() {
        var buttonDefinition = [
            {label: TranslationService.get("back"), action: self.back, type: 'dialogaction'},
             {
                 label: TranslationService.get('print'),
                action: self.print
            }
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }

    function setRouteBasedFilter() {
        SearchFilter.setTenderId($routeParams.tenderId);
        SearchFilter.setLotId($routeParams.lotId);
        SearchFilter.setSupplierId($routeParams.supplierId);
    }

    $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
        if (newRoute.$$route.originalPath !== oldRoute.$$route.originalPath) {
            SearchFilterStorage.setSearchScrollPosition("vcatList", document.getElementById('search-view').scrollTop);
        }
    });
}
